import { render } from "./threat.vue?vue&type=template&id=6b94dfe5&scoped=true&ts=true"
import script from "./threat.vue?vue&type=script&lang=ts"
export * from "./threat.vue?vue&type=script&lang=ts"

import "./threat.vue?vue&type=style&index=0&id=6b94dfe5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b94dfe5"]])

export default __exports__